import React, { useEffect, useState, useRef } from 'react';
export const FeaturedSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.15
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="bg-[#fcfcf7] py-20 px-8" data-id="element-27">
      <div className="max-w-[1440px] mx-auto" data-id="element-28">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-29">
          <div className={`relative aspect-square rounded-2xl overflow-hidden flex flex-col items-center justify-center text-center p-12 md:p-32 transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'}`} style={{
          backgroundImage: 'url("https://cdn.shopify.com/s/files/1/0637/8940/0115/files/imgi_69_5f4e9939ee3b96921d9af4d502cbdd3edf2a3d2a.jpg?v=1763953425")',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }} data-id="element-30">
            {/* Soft gradient wash to make text readable */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/15 to-transparent" data-id="element-31"></div>
            {/* Rotated Side Label */}
            <p className="absolute left-8 text-white/75 text-xs font-light uppercase tracking-wider font-mono whitespace-nowrap z-20" style={{
            top: '50%',
            transform: 'rotate(-90deg) translateX(-50%)',
            transformOrigin: 'left center'
          }} data-id="element-32">
              FAITH + BIBLICAL WELLNESS
            </p>
            {/* Center Content */}
            <div className="flex flex-col items-center gap-6 z-20" data-id="element-33">
              {/* Clean minimal title frame */}
              <div className="text-center px-5 py-1.5 rounded-md" data-id="element-34">
                <h2 className="text-white text-3xl md:text-3xl font-light tracking-tight" data-id="element-35">
                  Faith & Fig
                </h2>
              </div>
              <p className="text-white/95 text-sm md:text-lg font-light max-w-md" data-id="element-36">
                Because wellness is rooted in faith and nourished by God.
              </p>
              <a href="https://learnmore.faithandfig.com" className="inline-flex justify-center items-center bg-white text-primary px-8 py-3 rounded-full hover:bg-white/90 transition-all duration-300 text-sm font-medium" data-id="element-37">
                Read More
              </a>
            </div>
          </div>
          {/* Right Card - Order Tracking */}
          <div className={`relative aspect-square rounded-2xl overflow-hidden flex flex-col items-center justify-center text-center p-10 md:p-16 transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'}`} style={{
          backgroundImage: 'url("https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_7filwq7filwq7fil.png?v=1763955465")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transitionDelay: '200ms'
        }} data-id="element-38">
            {/* Soft gradient wash */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/20 to-transparent" data-id="element-39" />
            <div className="flex flex-col items-center gap-4 z-20" data-id="element-40">
              <h3 className="text-white text-2xl md:text-3xl font-light leading-snug" data-id="element-41">
                Track your order
                <br data-id="element-42" />
                with peace of mind.
              </h3>
              <p className="text-white/90 text-xs md:text-base font-light max-w-xs md:max-w-md" data-id="element-43">
                See where your Faith &amp; Fig package is on its journey.
              </p>
              <a href="https://faithandfig.com/apps/track123" className="inline-flex justify-center items-center bg-white text-primary px-8 py-3 rounded-full hover:bg-white/90 transition-all duration-300 text-sm font-medium" data-id="element-44">
                Track Your Order
              </a>
              {/* Rotated Side Label */}
              <p className="absolute left-8 text-white/75 text-xs font-light uppercase tracking-wider font-mono whitespace-nowrap z-20" style={{
              top: '50%',
              transform: 'rotate(-90deg) translateX(-50%)',
              transformOrigin: 'left center'
            }} data-id="element-45">
                PEACE + FREE SHIPPING FOREVER
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};